module.exports = __webpack_public_path__ + "img/zzlogo.b68b3eec.png";